// extracted by mini-css-extract-plugin
export var alignDiscLeft = "n_qw d_fp d_bG d_dv";
export var alignLeft = "n_qj d_fp d_bG d_dv";
export var alignDiscCenter = "n_qx d_fq d_bD d_dw";
export var alignCenter = "n_bP d_fq d_bD d_dw";
export var alignDiscRight = "n_qy d_fr d_bH d_dx";
export var alignRight = "n_qk d_fr d_bH d_dx";
export var footerContainer = "n_qz d_dW d_bW";
export var footerContainerFull = "n_qB d_dT d_bW";
export var footerHeader = "n_kf d_kf";
export var footerTextWrapper = "n_qC d_w";
export var footerDisclaimerWrapper = "n_km d_km d_ck";
export var badgeWrapper = "n_qD d_w d_bz d_bP d_bF d_bJ";
export var verticalTop = "n_qF d_bz d_bJ d_bN d_bL";
export var wide = "n_qG d_cy";
export var right = "n_qH d_bK";
export var line = "n_fk d_fl d_cv";
export var badgeDisclaimer = "n_qJ d_bC d_bP d_bJ";
export var badgeContainer = "n_qK d_bz d_bH d_bP";
export var badge = "n_qL";
export var padding = "n_qM d_c7";
export var end = "n_qN d_bH";
export var linkWrapper = "n_qP d_dB";
export var link = "n_mC d_dB";
export var colWrapper = "n_qQ d_cx";
export var consent = "n_f d_f d_bC d_bP";
export var disclaimer = "n_qR d_bz d_bJ";
export var media = "n_qS d_bx d_dy";
export var itemRight = "n_qT";
export var itemLeft = "n_qV";
export var itemCenter = "n_qW";
export var exceptionWeight = "n_qX s_rV";